import { Platform } from 'react-native';
import { FIELD_MODE_ON_PHONE } from '@constants/fieldMode';
import { useResponsiveLayout } from './useResponsiveLayout';

/**
 * True only on the phone-sized website (web, width under 768) while
 * FIELD_MODE_ON_PHONE is on. Native and wider web never get it. Every field
 * mode gate reads this hook, so `grep -rn useFieldMode` lists them all.
 */
export function useFieldMode(): boolean {
  const { isMobile } = useResponsiveLayout();
  return FIELD_MODE_ON_PHONE && Platform.OS === 'web' && isMobile;
}
